import { useQuery } from "@tanstack/react-query";
import { contractorDetailsApi } from "../api/contractorApi";

export const useFetchRegionalBreakdown = (contractorId: string | null) => {

    const { data, isFetching, isPending, isError, error, refetch } = useQuery({
        queryKey: ["contractor-regional-breakdown", contractorId],
        queryFn: () => contractorDetailsApi.fetchRegionalBreakdown(contractorId),
        enabled: !!contractorId,
    });

    return {
        data: data,
        isLoading: isFetching || isPending,
        isError,
        error,
        refetch,
    };

};